import {FulfillmentText} from '../components/inventory/InventoryTerms';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const OrderSuccessPage = () => {
  const [order] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('tistore_last_order') || 'null'); }
    catch { return null; }
  });

  return (
    <div className="min-h-screen bg-brand-surface dark:bg-[#1E1E1E] transition-colors">
      <Header />

      <main className="pt-24 pb-24">
        <div className="max-w-md mx-auto px-4 text-center">
          <CheckCircle className="w-20 h-20 text-brand-text mx-auto mb-6" />
          <h1 className="text-2xl md:text-3xl font-medium mb-4 text-brand-text dark:text-brand-text">
            Заказ оформлен!
          </h1>

          {order?.customer?.email && <p className="text-sm mb-6">Подтверждение и изменения статуса отправим на {order.customer.email}.</p>}
          <FulfillmentText lines={order?.fulfillment||[]}/>
          {order?.pickup_code && (
            <div className="rounded-xl border border-brand-border dark:border-brand-border bg-brand-surface dark:bg-brand-surface p-5 mb-6">
              <p className="text-sm text-brand-text dark:text-brand-text mb-1">Код получения заказа самовывозом</p>
              <p className="text-3xl font-bold tracking-[0.25em] text-brand-text dark:text-brand-text">{order.pickup_code}</p>
              <p className="text-xs text-brand-text dark:text-brand-text mt-2">Покажите этот код менеджеру при получении.</p>
            </div>
          )}
          {order?.coins_earned > 0 && (
            <div className="rounded-xl bg-brand-surface dark:bg-brand-accent/20 border border-brand-border dark:border-brand-border p-4 mb-6 text-left">
              <p className="font-medium text-brand-text dark:text-brand-text">После получения заказа вам начислим {order.coins_earned} бонусов — 10% от покупки.</p>
              <p className="text-sm text-brand-text dark:text-brand-text mt-1">Бонусами можно оплатить до 15% суммы следующего заказа.</p>
            </div>
          )}
          
          <div className="bg-brand-surface dark:bg-brand-accent/20 border border-brand-border dark:border-brand-border rounded-lg p-4 mb-8">
            <p className="text-brand-text dark:text-brand-text text-sm md:text-base">
              💬 Пока вы можете{' '}
              <a 
                href="https://t.me/tistore_tg" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-medium text-brand-text dark:text-brand-text hover:underline"
              >
                подписаться на наш канал
              </a>{' '}
              и ожидать сообщения в течение дня от аккаунта менеджера{' '}
              <a 
                href="https://t.me/timhorn" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-medium text-brand-text dark:text-brand-text hover:underline"
              >
                @timhorn
              </a>.
            </p>
          </div>

          <Link to="/">
            <Button className="bg-brand-accent dark:bg-brand-accent text-brand-text dark:text-brand-text hover:bg-brand-surface dark:hover:bg-brand-surface">
              Вернуться к покупкам
            </Button>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default OrderSuccessPage;
